const VIDEO_FILE_PATTERN = /\.(?:mp4|webm)$/i;
const YOUTUBE_ID_PATTERN = /^[a-zA-Z0-9_-]{6,20}$/;
const VIMEO_ID_PATTERN = /^\d{5,15}$/;
const APARAT_ID_PATTERN = /^[a-zA-Z0-9_-]{3,32}$/;

const parseUrl = (value) => {
  const rawValue = String(value || '').trim();
  if (!rawValue) throw new Error('لینک ویدیو را وارد کنید.');
  if (/^[a-z][a-z\d+.-]*:/i.test(rawValue) && !/^https?:/i.test(rawValue)) {
    throw new Error('لینک ویدیو باید با http یا https آغاز شود.');
  }

  try {
    return new URL(/^https?:\/\//i.test(rawValue) ? rawValue : `https://${rawValue}`);
  } catch (_) {
    throw new Error('آدرس ویدیو معتبر نیست.');
  }
};

const cleanHostname = (url) => url.hostname.toLowerCase().replace(/^www\./, '');

export const getArticleVideoData = (value) => {
  const url = parseUrl(value);
  const hostname = cleanHostname(url);
  const pathParts = url.pathname.split('/').filter(Boolean);

  if (hostname === 'youtu.be' || hostname === 'youtube.com' || hostname === 'm.youtube.com' || hostname === 'youtube-nocookie.com') {
    let videoId = '';
    if (hostname === 'youtu.be') videoId = pathParts[0] || '';
    else if (url.pathname === '/watch') videoId = url.searchParams.get('v') || '';
    else if (['embed', 'shorts', 'live'].includes(pathParts[0])) videoId = pathParts[1] || '';

    if (!YOUTUBE_ID_PATTERN.test(videoId)) {
      throw new Error('شناسه ویدیوی YouTube در این لینک معتبر نیست.');
    }

    return {
      provider: 'youtube',
      src: `https://www.youtube-nocookie.com/embed/${videoId}`,
      title: 'ویدیوی YouTube',
    };
  }

  if (hostname === 'vimeo.com' || hostname === 'player.vimeo.com') {
    const videoId = hostname === 'player.vimeo.com' && pathParts[0] === 'video'
      ? pathParts[1]
      : [...pathParts].reverse().find((part) => VIMEO_ID_PATTERN.test(part));

    if (!VIMEO_ID_PATTERN.test(videoId || '')) {
      throw new Error('شناسه ویدیوی Vimeo در این لینک معتبر نیست.');
    }

    return {
      provider: 'vimeo',
      src: `https://player.vimeo.com/video/${videoId}`,
      title: 'ویدیوی Vimeo',
    };
  }

  if (hostname === 'aparat.com' || hostname.endsWith('.aparat.com')) {
    const embeddedHashIndex = pathParts.findIndex((part) => part.toLowerCase() === 'videohash');
    const videoHash = embeddedHashIndex >= 0
      ? pathParts[embeddedHashIndex + 1]
      : pathParts[0]?.toLowerCase() === 'v' ? pathParts[1] : '';

    if (!APARAT_ID_PATTERN.test(videoHash || '')) {
      throw new Error('شناسه ویدیوی آپارات در این لینک معتبر نیست.');
    }

    return {
      provider: 'aparat',
      src: `https://www.aparat.com/video/video/embed/videohash/${videoHash}/vt/frame`,
      title: 'ویدیوی آپارات',
    };
  }

  if (VIDEO_FILE_PATTERN.test(url.pathname)) {
    return {
      provider: 'file',
      src: url.toString(),
      title: decodeURIComponent(pathParts[pathParts.length - 1] || 'فایل ویدیو'),
    };
  }

  throw new Error('لینک باید متعلق به YouTube، آپارات، Vimeo یا یک فایل MP4/WebM باشد.');
};
